<template>
    <div class="assignment-grid">
        <!-- <div class="assignment-grid-background" :style="{backgroundImage: 'url(' + backgroundUrl + ')'}"></div> -->
        <div class="assignment-grid-title">
            <span>{{gridTitle}}</span>
            <p>Je hebt een uitnodiging gehad om de korte cursus te doen. Gefeliciteerd, dit betekent dat je de quiz goed hebt gedaan!<br/><br/>
            Linksonder staan 8 modules met filmpjes die je eerst goed moet bekijken. Daarna klik je op de toets en probeer je de vragen te beantwoorden.<br/><br/>Good luck.</p>
            </div>
        <div class="assignment-grid-container">
            
            <span class="button-close" v-show="activeWindow !== 'chapter' && chapters.length >= 1" @click.prevent="onCloseWindow">
                <font-awesome-icon 
                    :icon="['fas', 'chevron-circle-up']"
                    class="font-awesome-icon" 
                    size="lg"
                />
                Terug
            </span>

            <div v-if="activeWindow === 'chapter'" class="agile-wrapper chapter-agile-wrapper">
                <agile ref="agileChapter" :dots="false" :slides-to-show="agileChapter.slidesToShow" :infinite="false" v-on:afterChange="updateAgileNavigationNextButton">
                    <div class="slide" v-for="(chapter, index) in chapters" :key="chapter.code" @click.prevent="onClickChapter(chapter, index)">
                        <div class="thumbnail">
                            <img :src="chapter.icon">
                            <font-awesome-icon :icon="['far', 'play-circle']" class="font-awesome-icon solo-play-button" />
                            <span class="title">{{chapter.name}}</span>
                        </div>
                    </div>

                    <template slot="prevButton"><font-awesome-icon :icon="['fas', 'chevron-left']" :size="navButtonSize"/></template>
                    <template ref="chapterNextButton" slot="nextButton"><font-awesome-icon ref="chapterNextIcon" :icon="['fas', 'chevron-right']" :size="navButtonSize"/></template>
                </agile>
            </div>

            <div v-if="activeWindow === 'assignment'" class="agile-wrapper assignment-agile-wrapper">
                <agile ref="agileAssignment" :dots="false" :slides-to-show="agileAssignment.slidesToShow" :infinite="false" v-on:afterChange="updateAgileNavigationNextButton">
                    <div class="slide" v-for="(assignment, index) in selectedChapter.assignments" :key="assignment.code" @click.prevent="startAssignment(assignment.code)">
                        <div class="thumbnail">
                            <font-awesome-icon v-show="assignment.finished" class="check-icon" :icon="['fas', 'check-circle']" size="lg"/>
                            <img :src="assignment.icon">
                            <span v-if="!isIntro(assignment)" class="number">{{getAssignmentNumber(index)}}<font-awesome-icon :icon="['far', 'play-circle']" class="font-awesome-icon" :style="{'padding-left': getAssignmentNumber(index) ? '0.4em' : '0em'}" /></span>
                            <span class="title">{{assignment.title}}</span>
                        </div>
                    </div>

                    <div v-if="nextChapter" class="slide" @click.prevent="onClickChapter(nextChapter, selectedChapterIndex + 1)">
                        <div class="thumbnail">
                            <img :src="nextChapter.icon">
                            <span class="number"><font-awesome-icon :icon="['far', 'arrow-alt-circle-right']" class="font-awesome-icon" :style="{'padding-left': '0em'}" /></span>
                            <span class="title">{{nextChapter.name}}</span>
                        </div>
                    </div>

                    <template slot="prevButton"><font-awesome-icon :icon="['fas', 'chevron-left']" :size="navButtonSize"/></template>
                    <template ref="assignmentNextButton" slot="nextButton"><font-awesome-icon ref="assignmentNextIcon" :icon="['fas', 'chevron-right']" :size="navButtonSize"/></template>
                </agile>
            </div>
        </div>
    </div>
</template>

<script>
    import be from '../services/Backend';
    import Velocity from 'velocity-animate';

    export default {
        'props': {
            data: {}
        },
        'data': function () {
            return {
                cursus: null,
                chapters: [],
                assignments: [],
                selectedChapter: null,
                selectedChapterIndex: null,
                selectedAssignment: null,
                nextChapter: null,
                activeWindow: 'chapter',
                slideWidth: 317,
                agileChapter: {
                    slidesToShow: 0,
                    listWidth: 0,
                },
                agileAssignment: {
                    slidesToShow: 0,
                    listWidth: 0,
                },
                fitSlideCount: 0,
                agileOptions: {
                    dots: false,
                },
            }
        },
        'computed': {
            backgroundUrl: function() {
                if(this.selectedChapter) {
                    return 'https://cdn.organiq.nl/userfiles/mkbidee/images/' + this.selectedChapter.code;
                }

                if(this.cursus) {
                    return 'https://cdn.organiq.nl/userfiles/mkbidee/images/' + this.cursus.code;
                }

                return '';
            },
            navButtonSize: function() {
                if(window.innerWidth <= 768) {
                    return '2x';
                }

                return '4x';
            },
            gridTitle: function() {
                if(this.cursus) {
                    return this.cursus.description;
                }

                return '';
            },
        },
        'methods': {
            isIntro: function(assignment) {
                return assignment.code.includes('INTRO');
            },
            getAssignmentNumber: function(index) {
                index++;

                if(this.selectedChapter) {
                    if(this.selectedChapter.assignments.find(a => a.code.includes('INTRO'))) {
                        index -= 1;
                    }

                    if(index == 0) {
                        return null;
                    } else {
                        return index;
                    }
                }

                return null;
            },
            onClickChapter: function(chapter, index) {
                this.selectedChapter = chapter;
                this.selectedChapterIndex = index;
                this.activeWindow = "assignment";

                this.startIntro(this.selectedChapter);

                if(this.chapters.length > index) {
                    this.nextChapter = this.chapters[index + 1];
                } else {
                    this.nextChapter = null;
                }

                setTimeout(() => {this.reloadAgileAssignment()}, 0);
            },
            onCloseWindow: function() {
                switch(this.activeWindow){
                    case 'assignment':
                        this.activeWindow = 'chapter';
                        this.selectedChapter = null;
                        setTimeout(() => {this.reloadAgileChapter()}, 0);
                        break;
                }
            },
            startIntro: function(resourceGroup) {
                let introAssignment = resourceGroup.assignments.find(a => a.code.includes('INTRO'));
                console.log('intro', introAssignment);

                if(!introAssignment) {
                    return;
                }

                be.MIA.getAssignmentSessionLatest(introAssignment.code)
                    .then((session) => {
                        console.log('session', session);
                        if(session && session.status === 'finished') {
                            return;
                        }

                        this.$router.push({ name: 'assignment', params: { code: introAssignment.code } });
                    });
            },
            startAssignment: function(assignmentCode) {
                be.MIA.getAssignmentSessionLatest(assignmentCode)
                    .then((session) => {
                        this.$router.push({ name: 'assignment', params: { code: assignmentCode } });
                        // if(session && session.status === 'finished') {
                        //     this.$router.push({ name: 'score', params: { assignmentCode: assignmentCode } });
                        // } else {
                        //     this.$router.push({ name: 'assignment', params: { code: assignmentCode } });
                        // }
                    });
            },
            sortByCode: function(a, b) {
                if(a.code > b.code) {
                    return 1;
                }
                if(b.code > a.code) {
                    return -1;
                }
                return 0;
            },
            updateCarouselStyling: function(event) {
                if(window.innerWidth <= 768) {
                    this.slideWidth = 160;
                } else {
                    this.slideWidth = 317;
                }
                this.fitSlideCount = Math.max(Math.floor(window.innerWidth / this.slideWidth), 1);

                if(this.activeWindow === 'chapter') {
                    this.agileChapter.slidesToShow = this.chapters.length < this.fitSlideCount ? this.chapters.length : this.fitSlideCount;
                    this.agileChapter.listWidth = this.agileChapter.slidesToShow * this.slideWidth;

                    //this.$refs.agileChapter.settings.slidesToScroll = this.chapters.length - this.agileChapter.slidesToShow;
                    this.$refs.agileChapter.settings.slidesToShow = this.agileChapter.slidesToShow;
                    $(this.$refs.agileChapter.$el).find('.agile__list').css('width', this.agileChapter.listWidth);
                    
                    setTimeout(() => {
                        this.$refs.agileChapter.getWidth();
                        this.$refs.agileChapter.prepareCarousel();
                    }, 0)
                }

                if(this.activeWindow === 'assignment') {
                    this.agileAssignment.slidesToShow = this.selectedChapter.assignments.length < this.fitSlideCount ? this.selectedChapter.assignments.length : this.fitSlideCount;
                    this.agileAssignment.listWidth = this.agileAssignment.slidesToShow * this.slideWidth;

                    //this.$refs.agileChapter.settings.slidesToScroll = this.selectedChapter.assignments.length - this.agileAssignment.slidesToShow;
                    this.$refs.agileAssignment.settings.slidesToShow = this.agileAssignment.slidesToShow;
                    $(this.$refs.agileAssignment.$el).find('.agile__list').css('width', this.agileAssignment.listWidth);

                    setTimeout(() => {
                        this.$refs.agileAssignment.getWidth();
                        this.$refs.agileAssignment.prepareCarousel();
                    }, 0)
                }

                $(window).trigger('resize');
            },
            reloadAgileChapter: function() {
                if(!this.$refs.agileChapter) {
                    console.log('agileChapter ref not found');
                    return;
                }
                
                this.updateCarouselStyling();
                this.$refs.agileChapter.reload();

                this.updateAgileNavigationNextButton();

                this.$refs.agileChapter.goTo(0);
            },
            reloadAgileAssignment: function() {
                if(!this.$refs.agileAssignment) {
                    console.log('agileAssignment ref not found');
                    return;
                }

                this.updateCarouselStyling();
                this.$refs.agileAssignment.reload();

                this.updateAgileNavigationNextButton();

                let goToIndex = 0;
                if(this.selectedChapter.assignments.find(a => a.finished == false)) {
                    goToIndex = this.selectedChapter.assignments.findIndex(a => a.finished == false);
                } else {
                    if(this.nextChapter) {
                        goToIndex = this.selectedChapter.assignments.length;
                    } else {
                        goToIndex = this.selectedChapter.assignments.length - 1;
                    }
                }

                goToIndex -= this.agileAssignment.slidesToShow / 2;
                goToIndex = Math.min(goToIndex, this.selectedChapter.assignments.length - this.agileAssignment.slidesToShow + (this.nextChapter ? 1 : 0));

                this.$refs.agileAssignment.goTo(goToIndex > 0 ? Math.round(goToIndex) : 0);
            },
            updateAgileNavigationNextButton: function() {
                setTimeout(() => {
                    let disableNextButton = false;

                    // Chapter
                    if(this.$refs.agileChapter) {
                        if(this.$refs.agileChapter.settings.slidesToShow + this.$refs.agileChapter.currentSlide >= this.chapters.length) {
                            disableNextButton = true;
                        }
                    }

                    if(this.$refs.chapterNextIcon) {
                        if(disableNextButton) {
                            this.$refs.chapterNextIcon.parentElement.setAttribute('disabled', true);
                        } else {
                            this.$refs.chapterNextIcon.parentElement.removeAttribute('disabled');
                        }
                    }

                    // Assignment
                    if(this.$refs.agileAssignment) {
                        if(this.$refs.agileAssignment.settings.slidesToShow + this.$refs.agileAssignment.currentSlide >= this.selectedChapter.assignments.length + (this.nextChapter ? 1 : 0)) {
                            disableNextButton = true;
                        }
                    }

                    if(this.$refs.assignmentNextIcon) {
                        if(disableNextButton) {
                            this.$refs.assignmentNextIcon.parentElement.setAttribute('disabled', true);
                        } else {
                            this.$refs.assignmentNextIcon.parentElement.removeAttribute('disabled');
                        }
                    }

                }, 0);
            },
            hasFinishedAssignment: function(sessions) {
                return sessions.find(s => s.status === 'finished') ? true : false;
            },
        },
        mounted() {
            be.MIA.getCourse('mkbidee_course').done((course) => {
                this.cursus = course.resourceGroups.find(rg => rg.name == "cursus");
                if (this.cursus) this.startIntro(this.cursus);

                this.cursus.children.forEach((resourceGroup, index) => {
                    resourceGroup.assignments.sort(this.sortByCode);
                    resourceGroup.assignments.forEach((assignment, index) => {
                        be.MIA.getAssignmentSessions(assignment.code)
                            .then((sessions) => {
                                assignment.finished = this.hasFinishedAssignment(sessions);
                                this.$forceUpdate();

                                if(this.selectedChapter) {
                                    setTimeout(() => {
                                        this.reloadAgileAssignment();
                                    }, 0);
                                }
                            });
                    });

                    this.chapters.push(resourceGroup);
                });

                let assignmentGridData = this.$store.state.assignmentGridData;
                if(assignmentGridData && assignmentGridData.selectedChapter) {
                    this.selectedChapterIndex = assignmentGridData.selectedChapterIndex;
                    this.selectedChapter = assignmentGridData.selectedChapter;//this.chapters.find(c => c.code == assignmentGridData.selectedChapter.code);
                    this.activeWindow = assignmentGridData.activeWindow;
                    this.nextChapter = assignmentGridData.nextChapter;

                    if(this.selectedChapter) {
                        setTimeout(() => {
                            this.reloadAgileAssignment();
                        }, 0);
                    }
                }

                if(this.chapters.length == 1) {
                    this.onClickChapter(this.chapters[0]);
                }
                
                setTimeout(() => {
                    this.reloadAgileChapter();
                }, 0);
            });            

            window.addEventListener("resize", this.updateCarouselStyling);
            window.addEventListener("resize", this.updateAgileNavigationNextButton);
            
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.updateCarouselStyling);
            window.removeEventListener("resize", this.updateAgileNavigationNextButton);

            this.$store.commit('setAssignmentGridData', {
                selectedChapter: this.selectedChapter,
                selectedChapterIndex: this.selectedChapterIndex,
                activeWindow: this.activeWindow,
                nextChapter: this.nextChapter,
            });
        }
    }
</script>
